import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { DeviceBit } from '../../../models/DeviceBit';
import { DeviceRg } from '../../../models/DeviceRg';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { AccueilService } from '../../accueil.service';
import { GenericToastrService } from '../../../generic-components/generic-toastr/generic-toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';

export interface DeviceDialogData {
  deviceRg?: DeviceRg;
  deviceBit?: DeviceBit;
}

@Component({
  selector: 'app-device-details',
  imports: [MatDialogModule, MatListModule, CommonModule, MatButtonModule],
  templateUrl: './device-details.component.html',
  styleUrl: './device-details.component.css',
})
export class DeviceDetailsComponent implements OnInit {
  deviceBit?: DeviceBit;
  deviceRg?: DeviceRg;

  constructor(
    public dialogRef: MatDialogRef<DeviceDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public accueilService: AccueilService,
    public toastr: GenericToastrService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.deviceBit = this.data.bit;
    this.deviceRg = this.data.rg;
    if(this.deviceRg != undefined){
      this.spinner.show();
      this.accueilService.getDeviceRgUpdated(this.deviceRg.nomAgent, this.deviceRg.client?.libelleRg).subscribe(result => {
        this.deviceRg = result;
        this.spinner.hide();
      }, error => {
        this.toastr.openSnackBarProblem("Erreur lors du chargement du device RG !");
        this.spinner.hide();
      });
    }

  }

  close(): void {
    this.dialogRef.close();
  }
}
